export default __webpack_public_path__ + "static/media/sun-haze.97bfecec.svg";